(async () => {

  const { Fancybox } = await import("@fancyapps/ui");
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelectorAll('input[name="country_code"], input[name="language_code"]'),
        panel: this.querySelectorAll('ul'),
      };

      this.elements.panel.forEach((panel) => {
        panel.querySelectorAll('li').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      });

      // bind fancybox to the localization form so it opens the form in a modal
      Fancybox.bind("[data-fancybox=market-switcher]", { animated: true });
    }

    onItemClick(event) {
      const item = event.target;
      const collapsible = item.closest('collapsible-element');
      const collapsibleType = collapsible.dataset.type;
      const currentName = collapsible.querySelector('[data-current-name]');
      const currentCountryFlag = collapsible.querySelector('[data-current-flag]');

      // Update the hidden input value when the data-type in the parent target matches the input name (country_code or language_code)
      const input = [...this.elements.input].find(input => input.name === collapsibleType);
      if (input) input.value = item.dataset.value;

      // Update the current country/language name and country flag (src, alt and hidden class) in the collapsible trigger
      if (currentName) currentName.textContent = item.textContent;

      if (collapsibleType == 'country_code') {
        const newFlag = item.querySelector('img')?.src;
        currentCountryFlag?.classList.toggle('hidden', !newFlag);
        if (currentCountryFlag && newFlag) {
          currentCountryFlag.src = newFlag;
          currentCountryFlag.alt = item.textContent;
        }
      }

      // close collapsible after selection
      collapsible.toggle(collapsible.querySelector('[data-collapsible-group]'));
    }
  }
  customElements.define('localization-form', LocalizationForm);
})();
